import { useState } from "react";
import { GALLERY, HERO_IMAGES, LOGO_DARK } from "@/lib/constants";
import { useI18n } from "@/lib/i18n";
import Lightbox from "./Lightbox";

export default function Gallery() {
  const { t } = useI18n();
  const all = [HERO_IMAGES.champagne_pour, ...GALLERY];
  const [active, setActive] = useState(null);

  const open = (idx) => setActive(idx);
  const close = () => setActive(null);
  const prev = () => setActive((i) => (i === null ? null : (i - 1 + all.length) % all.length));
  const next = () => setActive((i) => (i === null ? null : (i + 1) % all.length));

  const Tile = ({ src, alt, idx, className, children }) => (
    <button
      onClick={() => open(idx)}
      data-testid={`gallery-tile-${idx}`}
      className={`relative overflow-hidden group ${className}`}
    >
      <img
        src={src}
        alt={alt}
        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-1000"
      />
      {children}
    </button>
  );

  return (
    <section
      id="gallery"
      data-testid="gallery-section"
      className="bg-[#F5F2EA] py-24 md:py-36"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-14 gap-5">
          <div>
            <p className="font-mono-accent text-[12px] text-[#7A2021] mb-5">
              {t("gallery.kicker")}
            </p>
            <h2
              data-testid="gallery-heading"
              className="font-serif-display text-6xl md:text-7xl lg:text-8xl leading-[0.9] tracking-tight text-[#1A1713]"
            >
              {t("gallery.heading")}
            </h2>
          </div>
          <p className="max-w-sm text-[#5C5449]">{t("gallery.subtitle")}</p>
        </div>

        {/* Bento grid */}
        <div className="grid grid-cols-6 grid-rows-[repeat(6,_minmax(120px,1fr))] gap-3 md:gap-5">
          <Tile src={all[0]} alt="Champagne service" idx={0} className="col-span-6 md:col-span-3 row-span-3">
            <div className="absolute bottom-4 right-4">
              <img src={LOGO_DARK} alt="Ladiosa's" className="h-16 md:h-20 w-auto object-contain" />
            </div>
          </Tile>
          <Tile src={all[1]} alt="Editorial plate" idx={1} className="col-span-3 md:col-span-2 row-span-2" />
          <div className="col-span-3 md:col-span-1 row-span-2 overflow-hidden bg-[#7A2021] flex items-center justify-center p-4">
            <p className="font-serif-display italic text-[#FDFBF7] text-3xl md:text-4xl text-center leading-tight">
              "Save room for the brûlée."
            </p>
          </div>
          <Tile src={all[2]} alt="Plated dish" idx={2} className="col-span-3 md:col-span-2 row-span-2" />
          <Tile src={all[3]} alt="Restaurant interior" idx={3} className="col-span-3 md:col-span-1 row-span-2" />
          <Tile src={all[4]} alt="Pasta" idx={4} className="col-span-3 md:col-span-2 row-span-2" />
          <Tile src={all[5]} alt="Brunch table" idx={5} className="col-span-6 md:col-span-4 row-span-3" />
          <Tile src={all[6]} alt="Side dish" idx={6} className="col-span-3 md:col-span-2 row-span-3" />
          <Tile src={all[7]} alt="Plated dish" idx={7} className="col-span-3 md:col-span-3 row-span-2" />
          <Tile src={all[8]} alt="Plated dish" idx={8} className="col-span-3 md:col-span-3 row-span-2" />
        </div>
      </div>

      <Lightbox
        images={all}
        index={active}
        onClose={close}
        onPrev={prev}
        onNext={next}
      />
    </section>
  );
}
